/* eslint-disable import/prefer-default-export */
export const dayArray = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
